import Box from '@mui/material/Box';
import { GlobalStyles, styled } from '@mui/material';
import { Provider as ChatProvider } from '@dpdgroupuk/cc-chat-fe';
import '@dpdgroupuk/cc-chat-fe/dist/components/ChatBotApp.css';
import { DpdSnackbarProvider, DeveloperToolbar } from '@dpdgroupuk/cc-dpd-ui';
import { useCallback } from 'react';
import Footer from './components/Footer/Footer';
import AppRoutes from './router/Routes';
import DpdUiAppBar from './components/DpdAppBar/DpdAppBar';
import { AuthBridge } from './components/AuthBridge';
import AuthProvider from './features/Auth/AuthProvider';
import { OverlayProvider } from './features/Overlay';
import { CustomSnackbarProvider } from './features/CustomSnackbar';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import WelcomeBanner from './components/WelcomeBanner/WelcomeBanner';
import DataProvider from './DataProvider';
import { CHAT_CONFIG, DEV_VIEW_SWITCHER } from './constants/env';

const StyledBox = styled(Box)({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

const StickyAppBar = styled(Box)({
  position: 'sticky',
  top: 0,
  zIndex: 1100,
});

const StyledContainer = styled(Box)({
  minHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
});

export default function App() {
  const appBarRef = useCallback(node => {
    if (!node) {
      return;
    }
    const observer = new ResizeObserver(([entry]) => {
      document.documentElement.style.setProperty(
        '--dpd-appbar-height',
        `${entry.borderBoxSize[0].blockSize}px`
      );
    });
    observer.observe(node);
  }, []);

  return (
    <OverlayProvider>
      <GlobalStyles
        styles={{
          'input[type="text"]:focus': { backgroundColor: 'inherit !important' },
          '#chat-container': {
            color: '#000000 !important',
            colorScheme: 'only light',
          },
        }}
      />
      <StyledBox>
        <CustomSnackbarProvider>
          <StyledContainer>
            <ChatProvider chatConfig={CHAT_CONFIG}>
              <AuthProvider>
                <DataProvider>
                  <AuthBridge>
                    <WelcomeBanner />
                    <ScrollToTop />
                    <StickyAppBar ref={appBarRef}>
                      <DpdSnackbarProvider>
                        <DpdUiAppBar />
                      </DpdSnackbarProvider>
                    </StickyAppBar>
                    <Box
                      component='main'
                      sx={{
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                      }}
                    >
                      <AppRoutes />
                    </Box>
                  </AuthBridge>
                </DataProvider>
              </AuthProvider>
            </ChatProvider>
          </StyledContainer>
          <Footer />
        </CustomSnackbarProvider>
      </StyledBox>
      <DeveloperToolbar enabled={DEV_VIEW_SWITCHER} />
    </OverlayProvider>
  );
}
